import { faCartShopping, faClock, faGift, faTruck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MDBBtn, MDBCarousel, MDBCarouselInner, MDBCarouselItem } from 'mdbreact'
import React from 'react'
import { NumericFormat } from 'react-number-format'

const Producto = () => {
    return (
        <div className='row producto-item'>
            <div className='col-md'>
                <MDBCarousel activeItem={1} length={3} showControls={true} showIndicators={true} thumbnails >
                    <MDBCarouselInner>
                        <MDBCarouselItem itemId="1">
                            <img className="d-block w-100" src="https://mdbootstrap.com/img/Photos/Slides/img%20(88).webp" alt="First slide" />
                        </MDBCarouselItem>
                        <MDBCarouselItem itemId="2">
                            <img className="d-block w-100" src="https://mdbootstrap.com/img/Photos/Slides/img%20(121).webp" alt="Second slide" />
                        </MDBCarouselItem>
                        <MDBCarouselItem itemId="3">
                            <img className="d-block w-100" src="https://mdbootstrap.com/img/Photos/Slides/img%20(31).webp" alt="Third slide" />
                        </MDBCarouselItem>
                    </MDBCarouselInner>
                </MDBCarousel>
            </div>
            <div className='col-md'>
                <h5>BLUSA BÁSICA TALLA ÚNICA</h5>
                <p>Busa básica</p>

                <div className='informacion-envio'>
                    <div className='informacion-envio-item'>
                        <FontAwesomeIcon icon={faTruck} />
                        <span> Envios a tosos el País</span>
                    </div>
                    <div className='informacion-envio-item'>
                        <FontAwesomeIcon icon={faGift} />
                        <span> Regala Calidad</span>
                    </div>
                    <div className='informacion-envio-item'>
                        <FontAwesomeIcon icon={faClock} />
                        <span> Tiempo de envio 5 a días</span>
                    </div>
                </div>
                <NumericFormat className='informacion-envio-precio' displayType="text" value={1000} prefix={'$'} thousandSeparator={true} />
                <div className='informacion-color'>
                    <span>Color</span>
                    <div>
                        <MDBBtn className='btn-colores-opciones' color="blue" />
                        <MDBBtn className='btn-colores-opciones' color="red" />
                        <MDBBtn className='btn-colores-opciones' color="black" />
                    </div>
                </div>
                <div className='informacion-anadir'>
                    <select >
                        <option value={1}>1</option>
                    </select>

                    <MDBBtn color="black"><FontAwesomeIcon icon={faCartShopping} /> AÑADIR AL CARRITO </MDBBtn>
                </div>
                <hr />
                <div className='informacion-comprar-ahora'>
                    <MDBBtn dark color="black" outline><FontAwesomeIcon icon={faCartShopping} /> COMPRAR AHORA </MDBBtn>
                </div>
            </div>

        </div>
    )
}

export default Producto